import { ui, when, s } from '@owenscorning/pcb.alpha';
import _ from 'lodash';

import Content from './Content';
import CampaignPreview from '../../../PageBuilder/campaign/campaign_preview';

const Campaign = Content('Campaign', UI => ({
  version: '0.2',
  displayName: 'Campaign',
  usage: 'route',
  paths: ['c'],
  read: ({ contents, metadata }) => {
    if (!_.isEmpty(contents) && !Array.isArray(contents)) {
      return { contents, metadata };
    }

    const content = { ...contents?.[0] };
    content.executions = (content.executions || []).map(execution => {
      if (execution) {
        // TODO would be nice to fetch and show the current redirect URL+name, since they sync only on publish
      }
      return execution;
    });

    return {
      contents: content,
      metadata,
    };
  },
  write: ({ contents, metadata }) => ({
    contents,
    metadata,
  }),
  sidebar: {
    builder: ui`Form`.of({
      description: ui`Text`({ label: 'Description' }),
      executions: ui`List`.of(
        ui`Form`.of({
          execution_type: ui`Choices`.of({
            qr: 'QR Code Redirect',
          })({ label: 'Execution Type', default: 'qr' }),
          [s._]: ui`AlertMessage`({
            message: 'Provide a name before publishing this execution',
            type: 'warning',
            visible: when`../name`.isnt.present,
          }),
          name: ui`Text`({ label: 'Execution Name' }),
          [s._]: ui`Tip`.of(
            'Execution is a friendly name for you to refer back to later. ' +
              'This should be indicative of what, where, when and/or how you are publishing the QR.'
          ),
          [s._]: ui`AlertMessage`({
            message: 'Provide a destination url before publishing this execution',
            type: 'warning',
            visible: when`../destination_url`.isnt.present,
          }),
          destination_url: ui`Text`({ label: 'Destination URL' }),
          [s._]: ui`Tip`.of(
            'URL should include UTM IDs if tracking is desired. ' +
              'For full details, please refer to the Campaign Standard Implementation Guide.'
          ),
          qr: ui`Form`.of({
            [s._]: ui`AlertMessage`({
              message: 'Save and publish your campaign to activate and download your QR code',
              type: 'info',
              visible: when`../qr_uuid`.isnt.present.and.when`../../destination_url`.is.present.and.when`../../name`.is
                .present,
            }),
            qr_uuid: ui`Text`({
              controlled: 'value',
              disabled: true,
              label: 'QR Code UUID',
            }),
            qr_path: ui`Text`({
              controlled: 'value',
              disabled: true,
              label: 'QR Code Path',
            }),
            templated: ui`Hidden`({ value: when`../qr/qr_uuid`.is.present.then(true).otherwise(false) }),
          })({
            visible: when`../execution_type`.is.equal.to('qr'),
          }),
        })
      )({
        label: 'Executions',
        singular: 'Execution',
        title: 'name',
        hideable: false,
      }),
    }),
  },
  view: Campaign.Renderer(UI),
}));

Campaign.Renderer = () => ({
  contents: CampaignPreview,
});

export default Campaign;
